export const messageCreator = {
    user: 'user',
    agent: 'agent',
    llm: 'llm',
    faq: 'faq'
}

export const widgetKeys = {
    stockDetails: 'StockDetails',
    chart: 'Chart',
    news: 'News',
    portfolioDetails: 'PortfolioDetails',
}

export const finAgentUrlPrefix = 'finagent://'

export const finAgentMenuType = {
    stock: 'stock',
    portfolio: 'portfolio',
}

export const snippetTableType = {
    checkbox: 1,
    switch: 2
}
